import { useRef, useState } from "react";
import BaseButton from "../../../components/ui/BaseButton";
import BaseCard from "../../../components/ui/BaseCard";
import { saveAs } from "file-saver";
import { downloadTimeSheet } from "../../../services/api/workOrder";
import { useMutation } from "@tanstack/react-query";
import { CircularProgress } from "@mui/material";

const PhysicalSignOffSheet = ({ formik, mode, workOrderId, workOrderRefId }) => {
  const physicalSheetFileInputRef = useRef(null);
  const {
    error: downloadError,
    data: timeSheetData,
    mutateAsync: downloadTimeSheetPdf,
  } = useMutation({
    mutationFn: downloadTimeSheet,
    onSuccess: (timeSheetBlob) => {
      const fileName = `workorder-${workOrderRefId}-timeSheet.pdf`;
      saveAs(timeSheetBlob, fileName);
    },
    onError: (error) => {
      console.error("Failed to download zip:", error);
    },
  });

  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const handleDownloadTimeSheet = async () => {
    setIsDownloadLoading(true);
    try {
      await downloadTimeSheetPdf(workOrderId);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloadLoading(false);
    }
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("physicalSheetFile", file);
    }
  };

  const createImagePreview = () => {
    const { physicalSheetFile } = formik.values;
    if (typeof physicalSheetFile !== "string") {
      return URL.createObjectURL(physicalSheetFile);
    }
    return null;
  };

  return (
    <div className="   !mb-[0px]">      <div>
      {mode === "WRITE" && (
        <div className="w-full border-2 border-dotted rounded !border-primary flex flex-col items-center py-5">
          <i className="fa-solid fa-paperclip text-primary text-4xl mb-3"></i>
          <p className="font-normal mb-2 text-base text-primary">
            If a physical sign-off sheet was used, kindly scan and upload the signed document here
          </p>
          <div>
            <input
              type="file"
              ref={physicalSheetFileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />

            {/* File Display Section */}
            <div>
              <BaseButton
                color="primary"
                className="w-[160px py-[6px]"
                onClick={() => physicalSheetFileInputRef.current.click()}
              >
                Choose File
              </BaseButton>
            </div>
          </div>
        </div>
      )}

      {formik?.values?.physicalSheetFile && mode === "WRITE" && (
        <div className="flex items-center justify-between bg-light rounded-md py-2 px-3 cursor-default">
          <div className="flex items-center">
            <img
              src={
                formik?.values?.physicalSheetFile.name
                  ? createImagePreview()
                  : formik?.values?.physicalSheetFile
              }
              alt="Profile Preview"
              className="h-14 w-14 object-cover rounded-sm"
            />
            <p className="ml-3">{formik?.values?.physicalSheetFile?.name}</p>
          </div>
        </div>
      )}
      {mode !== "WRITE" && (
        <div className="flex gap-10 w-full mb-8">
          {/* Platform Generated Sign-off Sheet */}
          <BaseCard
            className="col-span-2 pt-4 pb-4 xl:px-16 px-5 rounded-lg !mb-[0px] w-full flex "
            elevation={1}
           
          >
            <div className="!font-medium !text-primary flex cursor-pointer gap-2"  onClick={handleDownloadTimeSheet}>
              {isDownloadLoading ? (
                <>
                  {console.log("loading")}
                  <CircularProgress color="primary" size={18} />
                  <span>Downloading...</span>
                </>
              ) : (
                "Download Platform Generated Sign-off Sheet"
              )}
            </div>
          </BaseCard>

          {formik?.values?.physicalSheetFile && <BaseCard
            className="col-span-2 pt-4 pb-4 xl:px-16 px-5 rounded-lg !mb-[0px] w-full flex "
            elevation={1}
          >
            <div className="!font-medium !text-primary cursor-pointer" onClick={() => {
              const link = document.createElement("a");
              link.href = formik?.values?.physicalSheetFile;
              link.download = "";
              link.target = "_blank";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }} >Download Attached Sign-off Sheet</div>
          </BaseCard>}
        </div>
      )}




      {/* {formik.errors.file && (
            <p className="text-red-500  mt-2">{formik.errors.file}</p>
          )} */}
    </div>
    </div>
  );
};

export default PhysicalSignOffSheet;
